import { render, staticRenderFns } from "./LocalPricesMarkets.vue?vue&type=template&id=153af3a6"
import script from "./LocalPricesMarkets.vue?vue&type=script&lang=js"
export * from "./LocalPricesMarkets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports